import { ApplicationFormLayout } from '@layouts/ApplicationFormLayout/ApplicationFormLayout';
import { OoApplicationViewPage } from '@pages/OoApplicationViewPage/OoApplicationViewPage';
export const ApplicationDetailsPage = () => {
  return (
    <ApplicationFormLayout>
      <OoApplicationViewPage />
    </ApplicationFormLayout>
  );
};
